import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';

import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FileService } from '../service/file.service';

@Component({
  selector: 'dpi-file-download',
  imports: [FormsModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatButtonModule],
  templateUrl: './file-download.component.html',
  styleUrl: './file-download.component.scss'
})
export class FileDownloadComponent {
  @Input() form: FormGroup;

    constructor(private fb: FormBuilder, private service : FileService) {
      this.form = this.fb.group({
        fileName : ['', Validators.compose([Validators.required, Validators.minLength(3), Validators.maxLength(30)])],
      });
    };

    submit({value, valid} : FormGroup, ev: Event) {
      if(!valid) {
        return;
      }
      
      this.service.fileDownloadFixedPathBlob(value.fileName).subscribe({
        next: (blob: any) => {
          // action of file saving
          this.service.saveAs(blob, value.fileName);
        },
        error: (error: any) => {
          console.error('Error: ', error);
          // show error message to the user
        }
      });
    }

}
